<template>
  <page-option>
    <v-sheet class="fillheight overflow-hidden">
      <v-card>
          <v-card-title class="primary white--text">
            <v-avatar color="#E3FCF7" size="35">
              <v-icon color="#108F6E" size>mdi-layers</v-icon>
            </v-avatar>
            <div class="title-page"> {{ $t('sidebar.datastores_and_layers.name') }}</div>
          </v-card-title>

          <v-tabs
            v-model="tab"
            background-color="transparent"
            grow
          >
            <v-tab
              v-for="(t,index) in tabs"
              :key="index"
            >
              {{ t }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>

              <v-container>
                <v-layout row wrap>
                    <!-- <v-flex xs12 sm12 md6 lg4 v-for="(datastore, index) in datastores" :key="index">
                        <v-card class="text-xs-center ma-1" tile>
                            <v-card-text>
                                <h4>Datastore</h4>
                                <div class="flex-grow-0">
                                  <v-icon :size="120">mdi-database</v-icon>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer class="d-flex justify-space-between align-end" />
                                    <base-button
                                      type-action="delete"
                                      class="text-none ml-auto"
                                      small
                                      outlined
                                      @click.stop="onDeleteItem(item)"
                                      v-if="checkAccess('workspace.delete', item)"
                                    >
                                    </base-button>
                            </v-card-actions>
                        </v-card>
                    </v-flex> -->
                    <v-card
                      max-width="50%"
                      outlined
                      tile
                      v-for="(datastore, index) in datastores" :key="index"
                    >
                      <v-list-item three-line>
                        <v-list-item-avatar
                          tile
                          size="100"
                        >
                          <v-icon :size="100">mdi-database</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="text-h5">
                            DATASTORE NAME
                          </v-list-item-title>
                          <div class="text-overline">
                            WORKSPACE NAME
                          </div>
                        </v-list-item-content>

                      </v-list-item>

                      <v-card-actions>
                        <v-spacer class="d-flex justify-space-between align-end" />
                        <base-button
                          type-action="delete"
                          class="text-none ml-auto"
                          small
                          outlined
                          @click.stop="onDeleteItem(item)"
                          v-if="checkAccess('workspace.delete', item)"
                        >
                        </base-button>
                      </v-card-actions>
                    </v-card>
                </v-layout>
              </v-container>

            </v-tab-item>
            <v-tab-item>
              DEF
            </v-tab-item>
          </v-tabs-items>
        </v-card>
    </v-sheet>
  </page-option>
</template>

<script>
export default{
  data: () => ({
    tabs: ['Bộ dữ liêu', 'Lớp bản đồ'],
    tab: '',
    datastores: ['dsu1', 'dsu2', 'dsu3', 'dsu4'],
  })
}
</script>
